<script lang="ts">
import type { MaskitoOptions } from "@maskito/core"
import type { HTMLAttributes } from "vue"
import { useClass } from "~/composables/local/cn-class"

const onlyDigitsInput: MaskitoOptions = {
	mask: /^\d+$/,
	preprocessors: [toEnglishProcessor],
}
</script>

<script setup lang="ts">
const props = defineProps<{
	placeholder?: string
	class?: HTMLAttributes["class"]
}>()

defineEmits<{
	change: [string | number]
}>()

const slots = defineSlots<{
	prepend: []
	append: []
}>()

const modelValue = defineModel<string | number>({ required: false, default: "" })

const className = useClass(
	"flex items-center rounded-lg border border-input bg-transparent ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
	() => props.class,
)
</script>

<template>
	<div
		:class="className">
		<div
			v-if="slots.prepend"
			class="p-2">
			<slot
				name="prepend" />
		</div>

		<input
			v-bind="$attrs"
			v-model="modelValue"
			v-maskito="onlyDigitsInput"
			type="tel"
			:placeholder="placeholder"
			class="h-8 w-full rounded-lg border-none bg-transparent px-3 py-2 text-sm outline-none d-ltr disabled:cursor-not-allowed placeholder:text-end placeholder:text-muted-foreground/60 disabled:opacity-50 focus:outline-none"
			@change="$emit('change', modelValue)">

		<div
			v-if="slots.append"
			class="p-2">
			<slot
				name="append" />
		</div>
	</div>
</template>
